query ContractsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: ContractsFilterInput
) {
  contracts(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      organizationId
      organization {
        id
        title
      }
      title
      currency
      invoiceCurrency
      status
      dateFrom
      dateTo
      billingPeriodMonths
      paymentPeriodType
      paidPeriodDays
      canceledAt
      items {
        type
        title
        amount {
          value
          currency
        }
      }
      createdAt
    }
    count
  }
}
